import { VStack, Text, Box } from "@chakra-ui/react";

export default function EmptyState({ icon: Icon, title, description, action }) {
  return (
    <VStack spacing={3} py={10} textAlign="center">
      {Icon ? (
        <Box color="app-muted-fg">
          <Icon size={32} />
        </Box>
      ) : null}
      <VStack spacing={1}>
        <Text fontWeight="semibold">{title}</Text>
        {description ? (
          <Text fontSize="sm" color="app-muted-fg" maxW="360px">
            {description}
          </Text>
        ) : null}
      </VStack>
      {action}
    </VStack>
  );
}
